import AutocompleteOptionColourable from "components/AutocompleteOptionColourable";

const IconPopperMenuListItem = AutocompleteOptionColourable;

export default IconPopperMenuListItem;
